"use strict";
var m = require('./mathTimo');
var f = require('./fileTimo');
var fs = require('fs');
var jpeg = require('jpeg-js');
var d = require('./numberMethods');
var r = require('./numberRules');

if (typeof window === 'undefined') {
  // we are under node
  if (process && process.env.ALGOINCHILDPROCESS) {
    var getPixels = require('get-pixels');
    //console.log('child process up and running, waiting for message');
    process.on('message', function (obj) {
      //console.log('got message to child process:', obj.config.file);
      getPixels(obj.config.file, function (err, pixels) {
        analyzeImageExternal(pixels, obj.config, function (err, res) {
          //console.log('analyzeImage ready:', res);
          process.send({ id: obj.id, result: res });
        })
      })
    })
  }
}

var externalHeight = null;
var width = null;
var height = null;
var p1Mask = null;
var page1 = [];
var page2 = [];
var page1Page2Correlation = null;
var numberColor = null;
var areaLowLimit = null;
var maxOffset = null;
var intensityIterations = null
var blackPictureLimit = null;
var undefinedDigitsLimit = null;
var minConfidenceLevel = null;


var bMask = null;
var band = [];
var bandOffset = 0;


function max(a, b) {
  if (a > b) return a;
  return b;
}
function min(a, b) {
  if (a < b) return a;
  return b;
}
function between(a, b, c) {
  if (b < a) b = a;
  if (b > c) b = c;
  return b;
}

function copyPictureToPage(rawPicture, anyPage) {
  anyPage = [];
  var eHeight = rawPicture.height;
  var w = rawPicture.width;
  for (var y = 0; y < eHeight; y++) {
    for (var x = 0; x < w; x++) {
      var i = (y * w + x) * 4;
      var value = (rawPicture.data[i] * rawPicture.data[i] +
        rawPicture.data[i + 1] * rawPicture.data[i + 1] +
        rawPicture.data[i + 2] * rawPicture.data[i + 2]);
      anyPage[x + y * w] = value;
    }
  }

  anyPage = d.integrate3(anyPage, width);
  return anyPage;
}
var colori = 0
function checkColor(rawPicture, prec) {
  if (prec >= 1) return;
  if (numberColor == 'white') {
    var redCount = 0
    var greenCount = 0
    var blueCount = 0
    for (var i = 0; i < width * height; i++) {
      var red = rawPicture.data[i * 4]
      var green = rawPicture.data[i * 4 + 1]
      var blue = rawPicture.data[i * 4 + 2]
      if (red > green && red > blue) redCount++
      else if (green > red && green > blue) greenCount++
      else blueCount++
    }
    if (redCount > blueCount && redCount > greenCount) {
      for (var i = 0; i < width * height; i++) {
        var red = rawPicture.data[i * 4]
        var ratio = 1.41
        if (red != 0) ratio = Math.sqrt((rawPicture.data[i * 4 + 1] + rawPicture.data[i * 4 + 2]) / red)
        if (ratio > 1.41) ratio = 1.41
        rawPicture.data[i * 4] *= ratio
        rawPicture.data[i * 4 + 1] *= ratio
        rawPicture.data[i * 4 + 2] *= ratio
      }
    }
  }
}
/*function checkColorRatios_old(rawPicture) {
  var redSumN = 0
  var greenSumN = 0
  var blueSumN = 0
  var redSumBG = 0
  var greenSumBG = 0
  var blueSumBG = 0
  page1 = copyPictureToPage(rawPicture, page1)
  p1Mask = d.calculateMask(page1, width, numberColor, 0.65)
  for (var i = 0; i < height * width; i++) {
    if (p1Mask[i] != 0) {
      redSumN += rawPicture.data[4 * i]
      greenSumN += rawPicture.data[4 * i + 1]
      blueSumN += rawPicture.data[4 * i + 2]
    } else {
      redSumBG += rawPicture.data[4 * i]
      greenSumBG += rawPicture.data[4 * i + 1]
      blueSumBG += rawPicture.data[4 * i + 2]
    }
  }
  var redBlueRatioN = 1
  var redGreenRatioN = 1
  var greenBlueRatioN = 1

  var redBlueRatioBG = 1
  var redGreenRatioBG = 1
  var greenBlueRatioBG = 1
  if (blueSumN != 0) redBlueRatioN = (redSumN / blueSumN)
  if (blueSumBG != 0) redBlueRatioBG = (redSumBG / blueSumBG)
  if (greenSumN != 0) redGreenRatioN = (redSumN / greenSumN)
  if (greenSumBG != 0) redGreenRatioBG = (redSumBG / greenSumBG)
  if (blueSumN != 0) greenBlueRatioN = (greenSumN / blueSumN)
  if (blueSumBG != 0) greenBlueRatioBG = (greenSumBG / blueSumBG)

  //console.log('N rb rg gb = ', redBlueRatioN, redGreenRatioN, greenBlueRatioN, 'BG rb,rg,gb = ', redBlueRatioBG, redGreenRatioBG, greenBlueRatioBG)
  //  return { 'rb': redBlueRatioBG / redBlueRatioN, 'rg': redBlueRatioBG / redBlueRatioN, 'gb': greenBlueRatioBG / greenBlueRatioN }
  var k = 0.1
  if (numberColor == 'white') {
    for (var i = 0; i < width * height; i++) {
      var red = rawPicture.data[i * 4]
      var green = rawPicture.data[i * 4 + 1]
      var blue = rawPicture.data[i * 4 + 2]
      var rb = 0.5 * (redBlueRatioN + redBlueRatioBG)
      var rg = 0.5 * (redGreenRatioN + redGreenRatioBG)
      var gb = 0.5 * (greenBlueRatioN + greenBlueRatioBG)
      if (blue != 0) rb = between(0.5, red / blue, 2)
      if (green != 0) rg = between(0.5, red / green, 2)
      if (blue != 0) gb = between(0.5, green / blue, 2)
      //      if (i == 10) console.log('colors', red, green, blue, rb, rg, gb)
      rb = between(min(redBlueRatioN, redBlueRatioBG), rb, max(redBlueRatioN, redBlueRatioBG))
      rg = between(min(redGreenRatioN, redGreenRatioBG), rg, max(redGreenRatioN, redGreenRatioBG))
      gb = between(min(greenBlueRatioN, greenBlueRatioBG), gb, max(greenBlueRatioN, greenBlueRatioBG))
      var nominator = redBlueRatioN - redBlueRatioBG
      if (nominator != 0) rb = between(0.5, (k * (rb - redBlueRatioBG) / (nominator)) + 1, 2)
      else rb = 1
      nominator = redGreenRatioN - redGreenRatioBG
      if (nominator != 0) rg = between(0.5, (k * (rg - redGreenRatioBG) / (nominator)) + 1, 2)
      else rg = 1
      nominator = greenBlueRatioN - greenBlueRatioBG
      if (nominator != 0) gb = between(0.5, (k * (gb - greenBlueRatioBG) / (nominator)) + 1, 2)
      else gb = 1
            if(red<blue&&red<green){
              rb=1
              rg=1
            }
            if(blue<red&&blue<green){
              rb=1
              gb=1
            }
            if(green<blue&&blue<red){
              rg=1
              gb=1
            }
      var multi = rb * rg * gb
            if (multi > 1.4) multi = 1.4
            if (multi < 0.5) multi = 0.5
      rawPicture.data[i * 4] *= multi
      rawPicture.data[i * 4 + 1] *= multi
      rawPicture.data[i * 4 + 2] *= multi
            if (i == 10) {
              console.log('colors', red, green, blue, rb, rg, gb)
              console.log(rb, rg, gb)
            }
    }
  }
}*/
function checkColorRatios(rawPicture, prec) {
  if (prec < 1) return;
  var redN = 0
  var greenN = 0
  var blueN = 0
  var redBG = 0
  var greenBG = 0
  var blueBG = 0
  page1 = copyPictureToPage(rawPicture, page1)
  p1Mask = d.calculateMask(page1, width, numberColor, 0.65)
  for (var i = 0; i < height * width; i++) {
    if (p1Mask[i] != 0) {
      redN += rawPicture.data[4 * i]
      greenN += rawPicture.data[4 * i + 1]
      blueN += rawPicture.data[4 * i + 2]
    } else {
      redBG += rawPicture.data[4 * i]
      greenBG += rawPicture.data[4 * i + 1]
      blueBG += rawPicture.data[4 * i + 2]
    }
  }
  var average = (redN + greenN + blueN + redBG + greenBG + blueBG) / (3 * width * height)
  var lengthN = Math.sqrt(redN * redN + greenN * greenN + blueN * blueN)
  var lengthBG = Math.sqrt(redBG * redBG + greenBG * greenBG + blueBG * blueBG)
  if (lengthN == 0 || lengthBG == 0) return
  redN = redN / lengthN
  greenN = greenN / lengthN
  blueN = blueN / lengthN
  redBG = redBG / lengthBG
  greenBG = greenBG / lengthBG
  blueBG = blueBG / lengthBG
  for (var i = 0; i < width * height; i++) {
    var redP = rawPicture.data[4 * i]
    var greenP = rawPicture.data[4 * i + 1]
    var blueP = rawPicture.data[4 * i + 2]
    var lengthP = Math.sqrt(redP * redP + greenP * greenP + blueP * blueP)
    if (lengthP > average ) {
      redP = redP / lengthP
      greenP = greenP / lengthP
      blueP = blueP / lengthP
      var dN = Math.sqrt((redN - redP) * (redN - redP) + (greenN - greenP) * (greenN - greenP) + (blueN - blueP))
      var dBG = Math.sqrt((redBG - redP) * (redBG - redP) + (greenBG - greenP) * (greenBG - greenP) + (blueBG - blueP))
      var denominator = dN + dBG;
      if (denominator > 0) {
        var k = dBG / denominator
        var multi = 1
        if (numberColor == 'white') {
        var amplification=0.17
          multi = k * amplification + 1
        } else {
          ;
//        var amplification=0.10
//          multi = 1+amplification - amplification * k
        }
        rawPicture.data[4*i]*=multi
        rawPicture.data[4*i+1]*=multi
        rawPicture.data[4*i+2]*=multi
      }
    }
  }
}

function initPage1(rawPicture, prec) {
  width = rawPicture.width;
  externalHeight = rawPicture.height;
  height = externalHeight;
  //  page1 = copyPictureToPage(rawPicture, page1);
  //  d.debugFlag(1)
  //  d.debug('original')
  //  d.pageToConsole(d.calculateMask(page1, width, numberColor, 0.65), width)
//    checkColorRatios(rawPicture,prec)
  checkColor(rawPicture, prec)
  page1 = copyPictureToPage(rawPicture, page1);
  //  d.pageToConsole(d.calculateMask(page1, width, numberColor, 0.65), width)
  //  d.debugFlag(0)
}
function copyPage1ToPage2() {
  page2 = d.copyPage(page1, page2);
}
function correlatePage1ToPage2() {
  page1Page2Correlation = [];
  var overlapLimit = (height * maxOffset) | 0;
  for (var o = -overlapLimit; o < overlapLimit; o++) {
    var diffLeft = [];
    var diff = [];
    var diffRight = [];
    if (o < 0) {
      for (var y = 0; y < (height + o); y++) {
        for (var x = 0; x < width; x++) {
          if (x > 0) diffLeft.push(page1[(y - o) * width + (x - 1)] - page2[y * width + x]);
          diff.push(page1[(y - o) * width + x] - page2[y * width + x]);
          if (x < (width - 1)) diffRight.push(page1[(y - o) * width + (x + 1)] - page2[y * width + x]);
        }
      }
    }

    else {
      for (var y = 0; y < (height - o); y++) {
        for (var x = 0; x < width; x++) {
          if (x > 0) diffLeft.push(page1[(y) * width + (x - 1)] - page2[(y + o) * width + x]);
          diff.push(page1[(y) * width + x] - page2[(y + o) * width + x]);
          if (x < (width - 1)) diffRight.push(page1[(y) * width + (x + 1)] - page2[(y + o) * width + x]);
        }
      }
    }
    var value = min(m.variance(diffLeft), m.variance(diff));
    page1Page2Correlation[o + overlapLimit] = Math.round(min(value, m.variance(diffRight)));
  }
}
function page1Page2Offset() {
  return (m.minIndex(page1Page2Correlation) - ((maxOffset * height) | 0));
}
function page1Page2OffsetConfidenceLevel() {
  var min = m.min(page1Page2Correlation);
  if (min == 0) return 10000;
  var result = m.max(page1Page2Correlation) / min;
  return result;
}
function storeConfiguration(configuration) {
  if (configuration) {
    maxOffset = configuration.maxOffset || 0.65;
    minConfidenceLevel = configuration.minConfidenceLevel || 6;
    numberColor = configuration.numberColor || 'black';
    areaLowLimit = configuration.backGroundArea || 0.65;
    intensityIterations = configuration.intensityIterations || 3;
    blackPictureLimit = configuration.blackPictureLimit || 10;
    if (!configuration.undefinedDigitsLimit && configuration.undefinedDigitsLimit != 0) undefinedDigitsLimit = 2
    else undefinedDigitsLimit = configuration.undefinedDigitsLimit;
  }
}
function cropPicture(pixels, coordinates) {
  if (!pixels.width) pixels.width = pixels.shape[0];
  if (!pixels.height) pixels.height = pixels.shape[1];
  var pictureWidth = pixels.width
  var rawPicture = {}
  rawPicture.data = []
  rawPicture.width = coordinates[2] - coordinates[0] + 1
  rawPicture.height = coordinates[3] - coordinates[1] + 1;
  for (var y = coordinates[1]; y <= coordinates[3]; y++) {
    for (var x = coordinates[0]; x <= coordinates[2]; x++) {
      for (var i = 0; i < 4; i++)rawPicture.data.push(pixels.data[4 * (x + y * pictureWidth) + i])
    }
  }
  return rawPicture;
}
function getParam(n, bD) {
  var box = (bD.numberMaxHeight * bD.numberMaxWidth)
  if (box == 0) return 0
  if (n) {
    if (n.leftBottomDip) {
      if (n.leftBottomDip.size) {
        if (n.holes) {
          if (n.holes.length != 0) {
            return n.holes[0].size / n.leftBottomDip.size
          }
        }
      }
    }
  }
  return 0
}
var numberOfIndexes = 25
var sums = []
var counts = []
function initStats() {
  for (var i = 0; i < numberOfIndexes; i++) {
    sums[i] = 0
    counts[i] = 0
  }
}
function addStats(number, value) {
  if (number < numberOfIndexes) {
    sums[number] += value
    counts[number]++
  }
}
function getStats() {
  var text = ' '
  for (var i = 0; i < numberOfIndexes; i++) {
    if (counts[i] != 0) text += ',' + i + ',' + (sums[i] / counts[i]).toFixed(2)
    else text += ',' + i + ','
  }
  return text
}
String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};

var numberSizeRatioLimit = 0.22


function detectNumberFromPixelArray2(pixels, coordinates, givenBandD, intermediate) {
  var defaultResult = {
    'number': undefined, 'numbers': [], 'firstDecimal': 0, 'iteration': 0,
    'usedAreaLowLimit': areaLowLimit, 'param': 0
  }
  var bandD = {}
  if (givenBandD) bandD = givenBandD;
  if (!coordinates || coordinates.length == 0) return defaultResult
  if (!pixels) return defaultResult;
  if (coordinates[0] > coordinates[2]) {
    var value = coordinates[0]
    coordinates[0] = coordinates[2]
    coordinates[2] = value
  }
  if (coordinates[1] > coordinates[3]) {
    var value = coordinates[1]
    coordinates[1] = coordinates[3]
    coordinates[3] = value
  }
  var newCoordinates = []
  newCoordinates[0] = coordinates[0] - 1
  newCoordinates[1] = coordinates[1] - 1
  newCoordinates[2] = coordinates[2] + 1
  newCoordinates[3] = coordinates[3] + 1
  var firstDecimal = null
  var numberData = {}
  var initialBackGroundArea = areaLowLimit
  var rawPicture = cropPicture(pixels, newCoordinates)
  var numberResults = {}
  numberResults.numberList = []
  var numbers = [];
  var iteration = -1
  var numberSizeRatio = 0
  initPage1(rawPicture, bandD.precision)
  if (page1.length == 0) return defaultResult
  var numberResultsList = []
  var relatedDigits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 4, 8, 8, 4, 4, 6, 6, 6, 1, 1, 1, 9, 8, 8, 7, 5, 6, 3, 5, 4, 3, 6, 1, 6, 4, 5, 5, 8, 6, 8]
  var indexIteOfsts = [2, 1, 2, 3, 1, 3, 3, 1, 1, 3, 1, 1, 1, 1, 1, 2, 2, 3, 1, 1, 1, 3, 1, 1, 1, 3, 2, 3, 3, 1, 3, 2, 1, 1, 1, 3, 3, 1, 2, 1, 1, 1, 1, 1]
  var lastIndex = indexIteOfsts.length - 1
  var detectRounds = 0
  var maxNumberOfDetectRounds = m.max(indexIteOfsts)
  if (bandD.debug == true) {
    d.debugFlag(2)
    d.debug('diffPage')
    d.pageToConsole(d.horisontalChanges(page1, width, numberColor), width)
    d.debugFlag(2)
    d.debug('0.65Page')
    d.pageToConsole(d.calculateMask(page1, width, numberColor, 0.65), width)
    d.debugFlag(2)
  }

  if (numberResults.numberList.length == 0) {
    iteration = 9
    p1Mask = d.horisontalChanges(page1, width, numberColor)
    numberData = d.createNumberData(p1Mask, width, bandD, true)
    if (firstDecimal === null) firstDecimal = r.determineFirstDecimal(numberData, bandD);
    numberResults = r.determineNumber(numberData, bandD)
    numberResults.firstDecimal = firstDecimal
  }

  if (numberResults.numberList.length == 0) {
    iteration = -1
    while (numbers.length == 0 && iteration < intensityIterations - 1 || numbers.length != 0 && indexIteOfsts[lastIndex] > 0) {
      numberResults = { 'numberList': [], 'indexList': [] }
      areaLowLimit = (initialBackGroundArea - iteration * 0.05);
      var ratio = 1
      if (ratio > numberSizeRatioLimit) {
        detectRounds++
        p1Mask = d.calculateMask(page1, width, numberColor, areaLowLimit)
        d.debug('number Color=' + numberColor + ' area Low Limit=' + areaLowLimit + ' iteration=' + iteration)
        numberData = d.createNumberData(p1Mask, width, bandD)
        if (firstDecimal === null) firstDecimal = r.determineFirstDecimal(numberData, bandD);
        numberResults = r.determineNumber(numberData, bandD)
        numberResults.firstDecimal = firstDecimal
        numbers = numberResults.numberList
        if (numbers.length > 0) {
          lastIndex = numberResults.indexList[0]
          indexIteOfsts[lastIndex]--
        }
      }
      iteration++;
      numberResultsList.push(numberResults)
      if (detectRounds >= maxNumberOfDetectRounds) indexIteOfsts[lastIndex] = 0
    }
    areaLowLimit = initialBackGroundArea
    var n = numberResultsList.length
    if (numberResultsList[n - 1].numberList.length == 0) {
      if (n >= 2) {
        if (numberResultsList[n - 2].numberList.length > 0) {
          numberResults = numberResultsList[n - 2]
          iteration--
        } else {
          if (n >= 3) {
            if (numberResultsList[n - 3].numberList.length > 0) {
              numberResults = numberResultsList[n - 3]
              iteration = iteration - 2
            }
          }
        }
      }
    }
  }
  if (numberResults.numberList.length == 0) {
    iteration = 5
    for (var i = 0; i < 3; i++) {
      if (numberResults.numberList.length == 0) {
        areaLowLimit = initialBackGroundArea + 0.10 + i * 0.05
        p1Mask = d.calculateMask(page1, width, numberColor, areaLowLimit)
        numberData = d.createNumberData(p1Mask, width, bandD)
        if (firstDecimal === null) r.determineFirstDecimal(numberData, bandD)
        numberResults = r.determineNumber(numberData, bandD)
        numberResults.firstDecimal = firstDecimal
        iteration++
        areaLowLimit = initialBackGroundArea
      }
    }
  }
  if (bandD.id) {
    var bgArea = 0
    if (iteration < 5) bgArea = initialBackGroundArea - (iteration - 1) * 0.05
    else if (iteration < 8) bgArea = initialBackGroundArea + 0.1 + (iteration - 5) * 0.05
    else bgArea = 1
    if (bgArea < 1) p1Mask = d.calculateMask(page1, width, numberColor, bgArea)
    if (bandD.debug == true) d.debugFlag(0)
  }
  return {
    'number': numberResults.numberList[0], 'numbers': numberResults.numberList, 'firstDecimal': numberResults.firstDecimal,
    'iteration': iteration, 'usedAreaLowLimit': bgArea, 'param': getParam(numberData, bandD),
    'index': numberResults.indexList[0], 'newCoordinates': newCoordinates
  }
}


var previousRealNumbers = []
var page2s = []
var previousMeterReading = undefined
var offsetss = []
var totalOffsets = []
var previousID = -1
function calculateMeterReading(digits) {
  if (digits.length < 2) return undefined;
  var result = digits[digits.length - 1].result
  if (result < 0) return undefined
  var multiplier = 10
  for (var i = digits.length - 2; i >= 0; i--) {
    if (digits[i].result >= 0) {
      result = digits[i].result * multiplier + result
      multiplier *= 10
    } else return result
  }
  return result;
}
function validMeterReading(previousReading, currentReading) {
  if (!previousReading) return false;
  if (!currentReading) return false;
  var multiplier = 1
  while (multiplier < previousReading && multiplier < currentReading) multiplier *= 10
  var previous = previousReading - (multiplier * ((previousReading / multiplier) | 0))
  var current = currentReading - (multiplier * ((currentReading / multiplier) | 0))
  if (current < previous) return false;
  return true;
}
function clearDiffNumbers(digits, number) {
  if (!number) return digits
  var multiplier = 10
  for (var i = digits.length - 1; i >= 0; i--) {
    if (digits[i].diffNumber == true) {
      digits[i].diffNumber = false;
      digits[i].result = -1
      digits[i].index = -1
    }
    if (number < multiplier) return digits
    multiplier *= 10
  }
  return digits
}
function analyzeImage(pixels, settings, givenBD, debug) {
  var positions = settings.digits.positions
  for (var i = 0; i < 10; i++) {
    if (!page2s[i]) page2s[i] = []
  }
  var debugIteration = givenBD.debugIteration
  var digits = []
  var digit = {}
  var jDigit = {}
  var masks = []
  var widths = []
  var offset = 0
  var cLevel = 0
  var realNumber = undefined
  var colors = []
  var definedDigitCount = 0
  var realLastDigit = undefined
  for (var p = positions.length - 1; p >= 0; p--) {
    givenBD.precision = positions[p].precision
    if (givenBD.debugDigit === p) givenBD.debug = true;
    else givenBD.debug = false;
    if (positions[p].precision > 1 && definedDigitCount == 0 && positions.length > 3 && p < positions.length - 1 - undefinedDigitsLimit) {
      digit = {}
      digit.numbers = []
    } else {
      if (settings.digits.inverted === 1) numberColor = 'white'
      if (settings.digits.inverted === 0) numberColor = 'black'
      if (settings.digits.positions[p].inverted === 1) numberColor = 'white'
      if (settings.digits.positions[p].inverted === 0) numberColor = 'black'
      digit = detectNumberFromPixelArray2(pixels, positions[p].coords, givenBD)
    }
    givenBD.debugIteration = debugIteration
    jDigit = {}
    jDigit.coords = positions[p].coords
    jDigit.precision = positions[p].precision
    if (digit.numbers.length != 0) {
      jDigit.result = digit.number
      jDigit.index = digit.index
      definedDigitCount++
    }
    else {
      jDigit.index = -1
      jDigit.result = -1
    }

    jDigit.digitHeight = givenBD.numberMaxHeight
    jDigit.firstDecimal = digit.firstDecimal
    jDigit.iteration = digit.iteration
    jDigit.usedAreaLowLimit = digit.usedAreaLowLimit
    jDigit.param = digit.param
    jDigit.newCoords = digit.newCoordinates
    digits[p] = jDigit
    masks[p] = []
    widths[p] = width
    if (givenBD.id) {
      for (var i = 0; i < p1Mask.length; i++)masks[p].push(p1Mask[i])
    }
    if (givenBD.diffNumbersInUse) {
      digits[p].diffNumber = false
      colors[p] = 'green'
      page2 = []
      for (var i = 0; i < page2s[p].length; i++)page2.push(page2s[p][i])
      realNumber = undefined
      if (digit.numbers.length != 0) {
        offset = -1
        if (page1.length == page2.length || page2.length != 0) {
          correlatePage1ToPage2()
          offset = page1Page2Offset()
          cLevel = page1Page2OffsetConfidenceLevel()
          if (offset < 0 || offset > 0.55 * h || cLevel < minConfidenceLevel) {
            offset = -1
          }
        }
        copyPage1ToPage2()
        realNumber = digit.firstDecimal * 0.01 + digit.numbers[0]
        totalOffsets[p] = 0;
      } else {
        if (page1.length == page2.length || page2.length != 0) {
          correlatePage1ToPage2()
          offset = page1Page2Offset()
          cLevel = page1Page2OffsetConfidenceLevel()
          if (m.average(page2) < blackPictureLimit) offset = -1
        } else {
          previousMeterReading = undefined;
          offset = -1
        }
        var h = page1.length / width
        if (offset < 0 || offset > 0.55 * h || cLevel < minConfidenceLevel || page2.length == 0) {
          copyPage1ToPage2()
          realNumber = undefined
          digits[p].offset = -1
        } else {
          if (previousRealNumbers[p]) {
            if (offset > 2) copyPage1ToPage2()
            else offset = 0;
            realNumber = previousRealNumbers[p] + offset / (givenBD.numberMaxHeight + givenBD.numberSeparatorMaxHeight)
            totalOffsets[p] += offset
            if (totalOffsets[p] > h) colors[p] = 'red'
            if (realNumber && realNumber < 9.5) {
              digits[p].diffNumber = true;
            } else {
              digits[p].diffNumber = false
              realNumber = undefined
            }
            var truncatedRealNumber = realNumber
            if (realNumber) {
              truncatedRealNumber = Math.round(realNumber)
              digits[p].result = truncatedRealNumber
              digits[p].index = truncatedRealNumber
            } else {
              digits[p].result = -1
              digits[p].index = -1
            }
          }
          else {
            copyPage1ToPage2()
            realNumber = undefined
          }
        }
      }
      if (offset >= 0) digits[p].offset = offset / (givenBD.numberMaxHeight + givenBD.numberSeparatorMaxHeight)
      else digits[p].offset = -1
      offsetss[p] = offset + 100
      previousRealNumbers[p] = realNumber
      page2s[p] = []
      for (var i = 0; i < page2.length; i++)page2s[p].push(page2[i])
    }
    if (p == positions.length - 1) realLastDigit = realNumber
  }
  var currentMeterReading = calculateMeterReading(digits)
  if (givenBD.id && previousID && (previousID == givenBD.id) && previousMeterReading && currentMeterReading) {
    if (!validMeterReading(previousMeterReading, currentMeterReading)) {
      digits = clearDiffNumbers(digits, currentMeterReading)
      console.log('NEGATIVE STEP', previousMeterReading, currentMeterReading)
      f.writeToFile('./errors.txt', 'Negative reading! ' + givenBD.id + ' ' + previousMeterReading + ' ' + currentMeterReading)
    }
  }
  previousID = givenBD.id
  previousMeterReading = currentMeterReading
  //  if (realNumber) realNumber.toFixed(2)
  if (givenBD.id) {
    for (var p = 0; p < digits.length; p++) {
      var pageP = masks[p]
      var ff = givenBD.fileName
      ff = ff.replaceAll(':', '_')
      if (digits[p].result >= 0) {
        var v = 100 + totalOffsets[p]
        if (digits[p].diffNumber == true) f.pageToFile('./98/' + digits[p].index + '/', givenBD.id + '_' + v + '_' + p + '_' + ff, pageP, widths[p], colors[p])
        else f.pageToFile('./' + digits[p].index + '/', givenBD.id + '_' + v + '_' + p + '_' + digits[p].iteration + '_' + ff, pageP, widths[p])
      } else {
        if (givenBD.numberMaxHeight && givenBD.numberMaxWidth) f.pageToFile('./100/', givenBD.id + '_' + p + '_' + digits[p].iteration + '_' + ff, pageP, widths[p])
        else f.pageToFile('./99/', givenBD.id + '_' + p + '_' + ff, pageP, widths[p])
      }
    }
  }
  return { 'digits': digits, 'realLastDigit': realLastDigit };
}

var analyzeImageExternal = function (pixels, config, callback, debug) {
  //var diffNumbersInUse = config.digits.diffNumbersInUse || false;
  var givenBD = { fileName: 'foo.txt', numberMaxHeight: config.digits.height, diffNumbersInUse: true, numberSeparatorMaxHeight: Math.round(config.digits.height * 0.25), numberMaxWidth: Math.round(config.digits.height * 0.66) }
  storeConfiguration(givenBD)
  var digits = analyzeImage(pixels, config, givenBD, debug)
  if (!callback) return digits;
  setTimeout(function () {
    callback(null, digits);
  }, 1)
};

module.exports = {
  analyzeImageInternal: function (pixels, aabb, config, givenBD, callback, debug) {
    if (config.digits.height) givenBD.numberMaxHeight = config.digits.height
    //    givenBD.diffNumbersInUse = true
    givenBD.numberSeparatorMaxHeight = Math.round(givenBD.numberMaxHeight * 0.25)
    givenBD.numberMaxWidth = Math.round(givenBD.numberMaxHeight * 0.66)
    storeConfiguration(givenBD)
    var digits = analyzeImage(pixels, config, givenBD, debug)
    if (!callback) return digits;
    setTimeout(function () {
      callback(null, digits);
    }, 1)
  },
  analyzeImage: analyzeImageExternal,
  analyzeDigits: function (obj, callback) {
    var pixels = obj.pixels;
    var config = obj.config;
    if (config && config.digits && config.digits.positions) {
      var positions = config.digits.positions;
      var givenBD = { fileName: 'foo.txt', numberMaxHeight: config.numberMaxHeight, numberMaxWidth: config.numberMaxWidth }
      storeConfiguration(givenBD);
      var digits = analyzeImageInternal(pixels, positions, givenBD);
      var result = { result: { digits: digits } };
      if (!callback) return result;
      setTimeout(function () {
        callback(null, result);
      }, 1)
    } else { return {} }
  },
  initStat: function () { return initStats() },
  getStats: function () { return getStats() }
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/digits-band.js
// module id = 829
// module chunks = 0